export enum DaypartsDatasetType {
  HOUR = 'HOUR',
  DAYOFWEEK = 'DAYOFWEEK',
  HEATMAP = 'HEATMAP'
}
